export default {
  title: {
    pt: 'Inspiration Dashbord',
    en: 'Inspiration Dashbord'
  },
  description: {
    pt: 'Parece que você está tentando acessar o Inspiration Dashboard por meio de um smartphone. Por enquanto, é possível acessar somente a partir de dispositivos com telas maiores.',
    en: 'It looks like you are trying to access Inspiration Dashboard from a smartphone. For now, it is only accessible from devices with larger screens.'
  },
  tablet_info: {
    pt: 'Está tentando acessar por meio de um tablet? Tente rotacionar a tela, deixando-a na orientação paisagem.',
    en: 'Trying to access from a tablet? Try rotating the screen to landscape orientation.'
  }
}
